export default __webpack_public_path__ + "static/create your own@3x-3414dd2d6882a7c67cee8d4ac240f135.png";